// Module
var code = "<button ng-show=\"$ctrl.showAddRoleButton\" ng-click=\"$ctrl.showRoleDialog()\" class=\"btn btn-primary mt-25\"> Add Role </button> ";
// Exports
export default code;